import tribunalAPI, { streamingAPI } from "api/tribunalAPi";
import {
  RequestTokenLaboral,
  ResponseTokenLaboral,
  ResponseVideoAudienciaInterface,
  SolicitudVideoAudienciaDetalle,
  ResponseStreamingLaboral
} from "interfaces/videoAudiencia/videoAudienciaInterface";

export const getDetalleVideoAudiencia = async (
  body: SolicitudVideoAudienciaDetalle
) => {
  let url = `video-audiencia/obtener/getDetallesAudienciaVideo`;
  return await tribunalAPI.get<ResponseVideoAudienciaInterface>(url, {
    params: body,
  });
};

export const getTokenVideoLaboral = async (body: RequestTokenLaboral) => {
  let url = `video-audiencia/obtener/generaTokenAudienciaVideo`;
  return await tribunalAPI.get<ResponseTokenLaboral>(url, {
    params: body,
  });
};

export const getVideoAudienciaService = async (body: ResponseStreamingLaboral) => {
  let url = `respuestaSolicitudVideo.php`;
  const formData = new FormData();
  formData.append('token', body.token);

  try {
    return await streamingAPI.post<ResponseStreamingLaboral>(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Para enviar FormData
      },
      responseType: 'json', // Asegura que la respuesta se maneje como JSON
    });
  } catch (error) {
    console.error('Error in POST request:', error);
    throw error;
  }
};

export const sendFormTerminosYCondiciones = async (data: any, url: string) => {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = url;
  form.target = "_blank";
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = data[key];
      form.appendChild(input);
    }
  }
  document.body.appendChild(form);
  form.submit();
  return Promise.resolve();
};
